import React from 'react'
import { Dropdown, Text } from '@mote/ui'
import styled, { css, th } from '@xstyled/styled-components'
import { Control } from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'

export const MoteCardRichPlaybackRateControl = props => {
  const {
    moteId,
    playbackRate,
    playbackRateOptions,
    onPlaybackRateChange,
    playerDimensions
  } = useMotePlayer()
  const [selectedIndex, setSelectedIndex] = React.useState(() =>
    playbackRateOptions.findIndex(rate => playbackRate === rate)
  )

  const options = React.useMemo(
    () =>
      playbackRateOptions.map(rate => {
        return (
          <PlaybackRateOption key={rate} selected={rate === playbackRate}>
            <Dropdown.ItemText>{rate}x</Dropdown.ItemText>
          </PlaybackRateOption>
        )
      }),
    [playbackRate]
  )

  React.useEffect(() => {
    setSelectedIndex(() =>
      playbackRateOptions.findIndex(rate => playbackRate === rate)
    )
  }, [playbackRate])

  return (
    <PlaybackRateRoot
      id={`playback-speed-${moteId}`}
      trigger='hover'
      width='max-content'
      onAction={onPlaybackRateChange}
      selectedItemIndex={selectedIndex}
      activeItemIndex={selectedIndex}
      orientation='horizontal'
      aria-label='Playback speed'
      triggerElement={
        <PlaybackRateTrigger
          size={36}
          variant='rich'
          tooltipProps={{
            content: 'Playback speed',
            direction: 'down',
            distance: 10
          }}
          aria-valuenow={playbackRate}
        >
          <Text
            tag='span'
            fontWeight={400}
            fontSize={14}
            color='white'
            aria-hidden={true}
            tabIndex={-1}
          >
            {playbackRate}x
          </Text>
        </PlaybackRateTrigger>
      }
      placement='top-center'
      showChevron={false}
      returnFocusOnClose={false}
      style={{
        left: playerDimensions?.width < 290 ? '100%' : null
      }}
      isSelectable
      {...props}
    >
      {options}
    </PlaybackRateRoot>
  )
}

const PlaybackRateTrigger = styled(Control)``

const PlaybackRateRoot = styled(Dropdown)`
  .dropdown-container {
    padding: 0 2px;
    box-shadow: none;
    height: 40px;
    border-radius: 20px;
    border: none;
    align-items: center;
    background: ${th.color('blackAlpha.500')};
  }
`

const PlaybackRateOption = styled(Dropdown.Item)`
  color: ${th.color('white')} !important;
  font-size: 12px;
  line-height: 36px;
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 50%;
  justify-content: center;

  &:focus,
  &:hover,
  &:active {
    background-color: ${th.color('black')} !important;
  }

  ${({ selected }) =>
    selected &&
    css`
      background-color: ${th.color('black')} !important;
    `};
`
